module.exports = __webpack_public_path__ + "static/media/event_add_white.0e706cdf.svg";